module.exports = __webpack_public_path__ + "static/media/3 10 Tulleord Blastell er feil.df1b5867.mp3";